import dynamic from 'next/dynamic';

import { SearchTermSuggestionsLoading } from './SearchTermSuggestions.Loading';

export const DynamicSearchTermSuggestions = dynamic(
  () => import(/* webpackChunkName: 'SearchTermSuggestions' */ './SearchTermSuggestions'),
  {
    loading: () => SearchTermSuggestionsLoading(),
    ssr: false,
  },
);

export * from './SearchTermSuggestions.Loading';
